import { CANCEL_RECURRENCE } from '../../../constants';

const initializeState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initializeState, { type, payload } = {}) {
  switch (type) {
    case CANCEL_RECURRENCE.LOAD:
      return {
        ...state,
        loading: true,
      };
    case CANCEL_RECURRENCE.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case CANCEL_RECURRENCE.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
